import React from 'react';
import {connect} from 'react-redux';

import RegisterSuccessPopup from './RegisterSuccessPopup';
import SuccessPopup from './SuccessPopup';
import FailPopup from './FailPopup';
import FeedbackPopup from './FeedbackPopup';
import {openSuccessPopup, openFailPopup} from '../../actions/Popup';
import {browserHistory} from 'react-router';

import {closePopup} from '../../actions/Popup';
import {Button} from '../Presentation/Forms';

class Popup extends React.Component {
    constructor(props) {
        super(props);
        this.close = this.close.bind(this);
        this.feedbackClose = this.feedbackClose.bind(this);
    }

    close() {
        this.props.dispatch(closePopup());
    }

    feedbackClose() {
        this.close();
        if (this.props.popupData.packCompleted && !this.props.popupData.medAlreadyCompleted) {
            this.props.dispatch(openSuccessPopup({
                title: "Честито!",
                text: `Ти приключи всички сесии от пакета "${this.props.popupData.packTitle}".`
            }));
        }
    }

    render() {

        let activePopup, close = this.close;
        let afterContent = null;

        switch(this.props.activePopup) {
            case 'RegisterSuccessPopup': activePopup = <RegisterSuccessPopup />; break;
            case 'FeedbackPopup':
                activePopup = <FeedbackPopup />;
                close = this.feedbackClose;
                afterContent = <Button text="Затвори" clickHandler={this.feedbackClose} />;
                break;
            case 'SuccessPopup': activePopup = <SuccessPopup {...this.props.popupData} />; break;
            case 'FailPopup': activePopup = <FailPopup {...this.props.popupData} />; break;
        }

        const show = activePopup ? true : false;

        return <div className={"popup-holder" + (show ? " active" : "")}>
            <div className={"rate-card" + (show ? " fade-in" : "")}>
                <button type="button" className="close-btn" onClick={close} />
                {activePopup}
                {afterContent}
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        activePopup: state.popup.activePopup,
        popupData: state.popup.popupData
    }
};

const mapDispatchToProps = (dispatch) => { return {dispatch} };

export default connect(mapStateToProps, mapDispatchToProps)(Popup);


// WEBPACK FOOTER //
// ./src/components/Popups/Popup.js